module.exports = __webpack_public_path__ + "img/p36.5a3f0508.svg";